<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addUser></addUser>
    </v-dialog>

</template>

<script>
    import {UserSettings} from '../../../store/namespace-helper'

    import addUser from '../../Shared/AddUser.vue'

    export default {
      name: 'add-new-users-dialog',
      components: {
        addUser
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[UserSettings.getters.getOpenNewUserDialogState]
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Settings/Users/AddUserDialog.vue